<template lang="pug">
  .notification-list.js-notification-list
    .notification-list__item
      .notification.turquoise
        .notification__icon
          img(src="@/assets/images/icons/notification-success.svg")
        .notification__text 2 новые заявки
        button.notification__button-close
          img(src="@/assets/images/icons/notification-close.svg")

    .notification-list__item
      .notification.orange
        .notification__icon
          img(src="@/assets/images/icons/notification-pending.svg")
        .notification__text Зявка №56283 была отменена
        button.notification__button-close
          img(src="@/assets/images/icons/notification-close.svg")

    .notification-list__item
      .notification.red
        .notification__icon
          img(src="@/assets/images/icons/notification-error.svg")
        .notification__text Срок рассмотрения зявки №3626 заканчивается через 24 часа
        button.notification__button-close
          img(src="@/assets/images/icons/notification-close.svg")
</template>

<script>
export default {
  name: "admin-notification",
};
</script>
